import { OrganizationProfileBody } from "./organization/updateOrganization";
import { Organization, QuiltySubscriptionPlanType, User } from "../../models";
import { SubscriptionPlanType } from "../../models/subscription";

export const rawUserKeys = [
    "affiliation",
    "citizenship",
    "city",
    "cookiesAccepted",
    "contractId",
    "country",
    "dateOfBirth",
    "downloadedReports",
    "email",
    "expertise",
    "firstName",
    "favorites",
    "lastName",
    "licenses",
    "newsletterEmail",
    "organizationSearchTracker",
    "password",
    "phone",
    "pictureProfile",
    "professionalInterests",
    "quiltyMarketMonitorEmails",
    "quiltyNewsletterEmails",
    "quiltyReportNotificaitonEmails",
    "referredBy",
    "registrationDate",
    "role",
    "roleInOrganization",
    "sex",
    "spaceSymposiumPicture",
    "state",
    "streetAddress",
    "termsAccepted",
    "userid",
    "zipcode",
] as const;

type BaseOrganization = OrganizationProfileBody &
    Pick<Organization, "organizationid" | "updatedAt">;
type BaseUser = Pick<User, typeof rawUserKeys[number]>;
interface BaseSubscription {
    plan: SubscriptionPlanType;
    active: boolean;
    endsAt?: string;
}

interface BaseQuiltySubscription {
    plan: QuiltySubscriptionPlanType;
    active: boolean;
    endsAt?: string;
    stripeId?: string;
}

export type RawUser = BaseUser & {
    organization?: BaseOrganization;
    subscription?: BaseSubscription;
    quiltySubscription?: BaseQuiltySubscription;
};

export interface SignInResponse {
    user: RawUser;
    token: string;
    sasToken: string;
}

export interface RefreshTokenResponse {
    token: string;
    sasToken: string;
}
